module.exports = __webpack_public_path__ + "static/media/search.a23e1037.png";